import React from 'react';

// Neutralised for the light purple theme.
// The decorative backdrop is now provided by #starfield-root in index.css
// (soft radial lavender gradients) so we simply render the root container.
function StarfieldBackground() {
  return <div id="starfield-root" aria-hidden="true" />;
}

export default StarfieldBackground;
